// Axios
import axios from "axios";

// Toast
import { toast } from 'react-toastify';

// Alert Dialog
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

// Helpers
import Helpers from ".";

// Config
import Config from '../config';

// Stores
import PaymentNotificationStore from '../mobx/stores/PaymentNotificationStore';
import AppStore from '../mobx/stores/AppStore';

const populates = "populate[0]=receipts&populate[1]=account_number&populate[2]=currency"

const getPaymentNotifications = async () => {
    const paymentNotificationsData = PaymentNotificationStore.paymentNotifications;

    if (PaymentNotificationStore.loadingItemStatus) {
        return; // İşlem devam ediyorsa, tekrar çağırmayı engelle
    }

    if (paymentNotificationsData.page > paymentNotificationsData.pageCount) {
        return; // Sayfa sayısı pageCount'ten büyükse, tekrar çağırmayı engelle
    }

    PaymentNotificationStore.setLoadingItemStatus(true);

    try {
        const response = await axios.get(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.paymentNotification}?filters[creator_user]=${Helpers.getUserData().id}&pagination[page]=${paymentNotificationsData.page}&pagination[pageSize]=12&sort=createdAt:desc&${populates}`,
            {
                headers: {
                    Authorization: `Bearer ${Helpers.getUserData().token}`,
                }
            }
        );

        response.data.data.forEach((paymentNotification: any) => {
            if (PaymentNotificationStore.paymentNotificationDatas[paymentNotification.id] === undefined) {
                PaymentNotificationStore.addPaymentNotificationData(paymentNotification.id, {
                    id: paymentNotification.id,
                    ...paymentNotification.attributes
                })
            }

            if (PaymentNotificationStore.paymentNotifications.content[paymentNotification.id] === undefined) {
                PaymentNotificationStore.addPaymentNotification(paymentNotification.id, {
                    id: paymentNotification.id,
                    ...paymentNotification.attributes
                })
            }
        });

        PaymentNotificationStore.setPaginationData(paymentNotificationsData.page + 1, response.data.meta.pagination.pageCount);
    } catch (error) {
        console.log('getPaymentNotifications:', error);
    }

    PaymentNotificationStore.setLoadingItemStatus(false);
};

const getPaymentNotification = async (id: number) => {
    PaymentNotificationStore.setLoadingItemStatus(true);

    try {
        const response = await axios.get(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.paymentNotification}?${populates}`,
            {
                headers: {
                    Authorization: `Bearer ${Helpers.getUserData().token}`,
                }
            }
        );

        response.data.data.forEach((paymentNotification: any) => {
            if (PaymentNotificationStore.paymentNotificationDatas[paymentNotification.id] === undefined) {
                PaymentNotificationStore.addPaymentNotificationData(paymentNotification.id, {
                    id: paymentNotification.id,
                    ...paymentNotification.attributes
                })
            }
        });
    } catch (error) {
        console.log('getPaymentNotification:', error);
    }

    PaymentNotificationStore.setLoadingItemStatus(false);
};

const createPaymentNotification = async (values: any) => {
    AppStore.setTransactionStatus(true);

    try {
        const formData = new FormData();
        formData.append('data', JSON.stringify(values));

        const receipts = values.receipts;
        delete values.receipts;

        if (receipts !== undefined) {
            Helpers.objectToArray(receipts).forEach((receipt: any) => {
                formData.append("receipts", receipt);
            })
        }

        AppStore.setLoadingStatus(true);

        const axiosOptions: any = {
            headers: {
                Authorization: `Bearer ${Helpers.getUserData().token}`,
                "Content-Type": "multipart/form-data",
            }
        }

        let progressStatus = false;
        if (receipts !== undefined) {
            if (receipts.length !== undefined) {
                progressStatus = true;
            }
        }

        if (progressStatus) {
            AppStore.resetLoadingPercent();
            AppStore.setLoadingStatus(true);

            axiosOptions['onUploadProgress'] = (progressEvent: any) => {
                let { loaded, total } = progressEvent;
                const percent: any = (loaded / total) * 100;
                AppStore.setLoadingPercent(percent.toFixed(0))

                if (percent === 100) {
                    AppStore.setLoadingStatus(false);
                }
            }
        }

        const response = await axios.post(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.paymentNotification}`, formData, axiosOptions);

        if (response.data.status) {
            toast(Helpers.translation(response.data.message));
        } else {
            confirmAlert({
                title: Helpers.translation('error'),
                message: Helpers.translation(response.data.message),
                buttons: [
                    {
                        label: Helpers.translation('i-got-it'),
                    }
                ]
            });
        }

        AppStore.setTransactionStatus(false);

        return response.data;
    } catch (error) {
        console.log('createPaymentNotification:', error);
        AppStore.setTransactionStatus(false);
    }
}

const searchPaymentNotifications = async (resetSearchRecord: boolean = false) => {
    const filters = PaymentNotificationStore.searchFilterText;

    if (filters !== "") {
        if (resetSearchRecord) {
            PaymentNotificationStore.resetSearchPaymentNotifications();

        }

        const searchPaymentNotificationsData = PaymentNotificationStore.searchPaymentNotifications;

        if (PaymentNotificationStore.loadingItemStatus) {
            return; // İşlem devam ediyorsa, tekrar çağırmayı engelle
        }

        if (searchPaymentNotificationsData.page > searchPaymentNotificationsData.pageCount) {
            return; // Sayfa sayısı pageCount'ten büyükse, tekrar çağırmayı engelle
        }

        PaymentNotificationStore.setLoadingItemStatus(true);

        try {
            const response = await axios.get(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.paymentNotification}?pagination[page]=${searchPaymentNotificationsData.page}&pagination[pageSize]=12&sort=createdAt:desc${filters}&${populates}`,
                {
                    headers: {
                        Authorization: `Bearer ${Helpers.getUserData().token}`,
                    }
                }
            );

            response.data.data.forEach((paymentNotification: any) => {
                if (PaymentNotificationStore.paymentNotificationDatas[paymentNotification.id] === undefined) {
                    PaymentNotificationStore.addPaymentNotificationData(paymentNotification.id, {
                        id: paymentNotification.id,
                        ...paymentNotification.attributes
                    })
                }

                if (PaymentNotificationStore.searchPaymentNotifications.content[paymentNotification.id] === undefined) {
                    PaymentNotificationStore.addSearchPaymentNotification(paymentNotification.id, {
                        id: paymentNotification.id,
                        ...paymentNotification.attributes
                    })
                }
            });

            PaymentNotificationStore.setSearchPaginationData(searchPaymentNotificationsData.page + 1, response.data.meta.pagination.pageCount);
        } catch (error) {
            console.log('searchPaymentNotifications:', error);
        }

        PaymentNotificationStore.setLoadingItemStatus(false);
    }
};

const exportHelpers = {
    getPaymentNotifications,
    getPaymentNotification,
    createPaymentNotification,
    searchPaymentNotifications
}

export default exportHelpers;